document.addEventListener("DOMContentLoaded", function () {

  const form = document.getElementById("contactForm");
  const successBox = document.getElementById("contactSuccess");
  const errorBox = document.getElementById("contactError");

  emailjs.init(form.dataset.emailjsPublicKey);

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    const data = {
      customer_name: form.customer_name.value,
      customer_email: form.customer_email.value,
      customer_phone: form.customer_phone.value,
      customer_message: form.customer_message.value
    };

    emailjs
      .send(form.dataset.emailjsServiceId, form.dataset.emailjsTemplateId, data)
      .then(() => {
        successBox.style.display = "block";
        form.reset();
      })
      .catch((error) => {
        console.error("EmailJS error:", error);
        errorBox.style.display = "block";
      });
  });

});
